/*********************** Custom JS for Boost AI Search & Discovery  ************************/
console.log('--- loaded ---');
if (window.boostSDAppConfig) {
    window.boostSDAppConfig.integration = Object.assign({
        labels: 'flair'
    }, window.boostSDAppConfig.integration || {});
}
var outSide = true;
//handle cart api 
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([(componentRegistry) => {
    componentRegistry.useModulePlugin('CartAPI', {
        name: 'The first FilterAPI plugin',
        apply(builder) {
            builder.on('methodFulfilled', 'addToCart', async (payload) => {
                const result = await payload.result.json();
                console.log('result: ', result);
                //   console.log('ok',payload);
                if (payload?.result?.status == 422) {
                    const popupCartErr = document.querySelector("#cart-popup");
                    popupCartErr.querySelector("p").innerHTML = result.message;
                    popupCartErr.style.display = 'block';
                    setTimeout(function() {
                        popupCartErr.style.display = 'none';
                    }, 3000)
                }
                return payload;
            });
        },
    });
    componentRegistry.useModulePlugin('FilterAPI', {
        name: 'Fix collection all returning incorrect data #745931',
        apply(builder) {
            builder.on('beforeMethodCall', 'get', (payload) => {
                if (boostSDAppConfig?.generalSettings?.collection_id == 506427736374) {
                    if (boostSDAppConfig?.additionalElementSettings?.default_sort_order && typeof boostSDAppConfig.additionalElementSettings.default_sort_order['506427736374'] !== 'undefined') {
                        payload.args[0].sort = boostSDAppConfig.additionalElementSettings.default_sort_order['506427736374'];
                    }
                }
            });
        },
    });
}]);
// START Boost hide colors in popup
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductSwatch', {
            name: 'customize click swatch1',
            apply: () => ({
                props: (props, element) => {
                    props.onClickOutSide = () => {};
                    let productItemRoot = element.getParentElm().getParentElm().getRootElm();
                    if (props.label?.toLowerCase() == "size") {
                        // Store the original onSelect function
                        const originalOnSelect = props.onSelect;
                        props.defaultSelectedValue = "";
                        element.getParams().props.defaultSelectedValue = null
                        // Modify onSelect behavior or add additional functionality
                        props.onSelect = (selectedValue) => {
                            originalOnSelect(selectedValue);
                            let productData = element.getParentElm().getParams().props.data;
                            let productItem = document.querySelector('[data-product-id="' + productData.id + '"] .boost-sd__popup-select-option > button');
                            const myTimeout = setTimeout(myStopFunction, 300);

                            function myStopFunction() {
                                productItem && productItem.click();
                            }
                        };
                    }
                    // console.log(125, props,productItemRoot)
                    if ((props.label?.toLowerCase() == "color" || props.options[0].labelAs == "color") && productItemRoot) {
                        var selectedElement = productItemRoot.querySelector('.boost-sd__product-swatch-option[is-selected="true"]');
                        // element.getRootElm().classList.add("container-colors")
                        setTimeout(function() {
                            var colorSwatch = element.getParams().props.options[0].label
                            var colorInput = document.querySelector(`.boost-sd__popup-select-option input[value="${colorSwatch}"]`);
                            if (!colorInput) return;
                            let rootColorSwatch = colorInput.parentNode.parentNode.parentNode.parentNode;
                            rootColorSwatch.classList.add("container-colors");
                        }, 10)
                        // Check if such an element exists
                        if (selectedElement) {
                            // Get the color attribute value
                            var color = selectedElement.getAttribute('data-color');
                            const triggerTimeout = setTimeout(triggerFunction, 300);

                            function triggerFunction() {
                                var chooseLabel = productItemRoot.querySelector(`input[value="${color}"]`);
                                if (chooseLabel) {
                                    // Get the parent element
                                    var parentElement = chooseLabel.parentNode; // Traverse up three levels to reach the parent element
                                    if (parentElement) {
                                        // console.log(parentElement,chooseLabel,parentElement.querySelector("label"))
                                        parentElement.querySelector("label").click();
                                    }
                                }
                            }
                        }
                    }
                    return props;
                },
            }),
        });
    }
]);
// END Boost hide colors in popup
// Start Boost change name of size options
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductSwatchOption', {
            name: 'customize click swatchOption',
            apply: () => ({
                props: (props, element) => {
                    let cItem = element.getRootElm();
                    let data = element.getParentElm().getParentElm().getParams()?.props.data?.variants;
                    let productItem = element.getParentElm().getParentElm().getParentElm().getRootElm();
                    // get full data product and change image second
                    let objectsWithTitleColor = [];
                    const lowStockText = '(Low in stock)';
                    const outOfStockText = '(Out of stock)';
                    if (!data) {
                        data = element.getParentElm().getParentElm().getParentElm().getParams()?.props.data?.variants;
                        let productItem = element.getParentElm().getParentElm().getParentElm().getParentElm().getRootElm();
                        // get full data product and change image second
                    }
                    if (!data) return props;
                    if (data) {
                        // Iterate over each object in the data array
                        data.forEach(function(obj) {
                            // Check if the title includes "Indigo"
                            if (obj.title.includes(props.value)) {
                                objectsWithTitleColor.push(obj);
                            }
                        });
                    }
                    setTimeout(function() {
                        if (productItem && productItem.classList.contains('boost-sd__product-item')) {
                            productItem.querySelectorAll('.boost-sd__popup-select-option .boost-sd__product-swatch-title').forEach(function(title) {
                                // Check if the text content includes 'Color Family' or 'Color'
                                if (title.textContent.includes('Color Family') || title.textContent.includes('Color')) {
                                    // If it does, find the closest parent with the class 'boost-sd__product-swatch' and hide it
                                    title.closest('.boost-sd__product-swatch').classList.add("color")
                                } else {
                                    title.closest('.boost-sd__product-swatch').classList.add("not-color")
                                }
                            });
                        }
                    }, 30)
                    //check not colors to change name variants
                    if (props.labelAs != "color" && props.labelAs != "image" && productItem) {
                        let selectedElement = productItem.querySelector('.boost-sd__product-swatch-option[is-selected="true"]');
                        if (selectedElement) {
                            // Get the color attribute value
                            let color = selectedElement.getAttribute('data-color');
                            let selectedItem = data.find(item => item.title === `${props.value} / ${color}`) || data.find(item => item.title === `${color} / ${props.value}`);
                            if (selectedItem) {
                                if (selectedItem.inventory_quantity > 0 && selectedItem.inventory_quantity < 4 && selectedItem.available) {
                                    props.label = props.label + " " + lowStockText;
                                }
                                if (!selectedItem.available || selectedItem.inventory_quantity <= 0) {
                                    props.label = props.label + " " + outOfStockText;
                                }
                            }
                        } else {
                            let selectedItem = data.find(item => item.merged_options[1].split(':')[1] === props.label);
                            if (selectedItem) {
                                if (selectedItem.inventory_quantity > 0 && selectedItem.inventory_quantity < 4 && selectedItem.available) {
                                    props.label = props.value + " " + lowStockText;
                                }
                                if (!selectedItem.available || selectedItem.inventory_quantity <= 0) {
                                    props.label = props.value + " " + outOfStockText;
                                }
                            }
                        }
                        setTimeout(function() {
                            document.querySelectorAll('label.boost-sd__radio-label.boost-sd__radio-label--non-radius').forEach(label => {
                                if (label.textContent.includes(outOfStockText)) {
                                    label.classList.add('out-of-stock');
                                }
                            });
                            document.querySelectorAll('.boost-sd__tooltip-content').forEach(tooltip => {
                                const tooltipText = tooltip.textContent;
                                if (tooltipText.includes(outOfStockText)) {
                                    tooltip.innerHTML = tooltipText.replace(outOfStockText, "<span>"+ outOfStockText +"</span>");
                                }
                                if (tooltipText.includes(lowStockText)) {
                                    tooltip.innerHTML = tooltipText.replace(lowStockText, "<span>" + lowStockText + "</span>");
                                }
                            });
                        }, 200)
                    } else {
                        function areAllColorVariantsOutOfStock(variants) {
                            // Filter variants with the color "Red"
                            const allVariants = variants.filter(variant => variant.merged_options.includes(`color:${props.value}`));
                            // Check if all red variants have an inventory quantity of 0 (out of stock)
                            return allVariants.every(variant => variant.inventory_quantity <= 0);
                        }
                        // Usage
                        if (areAllColorVariantsOutOfStock(data)) {
                            props.label = props.value + " " + outOfStockText;
                            setTimeout(function() {
                                document.querySelectorAll('label.boost-sd__radio-label.boost-sd__radio-label--non-radius').forEach(label => {
                                    if (label.textContent.includes(outOfStockText)) {
                                        label.classList.add('out-of-stock');
                                    }
                                });
                                document.querySelectorAll('.boost-sd__tooltip-content').forEach(tooltip => {
                                    const tooltipText = tooltip.textContent;
                                    if (tooltipText.includes(outOfStockText)) {
                                        tooltip.innerHTML = tooltipText.replace(outOfStockText, "<span>"+ outOfStockText +"</span>");
                                    }
                                    if (tooltipText.includes(lowStockText)) {
                                        tooltip.innerHTML = tooltipText.replace(lowStockText, "<span>" + lowStockText + "</span>");
                                    }
                                });
                            }, 200)
                        }
                    }
                    // end full data product and change image second
                    if (cItem && props.selected) {
                        var elements = document.querySelectorAll(".boost-sd__product-swatch-option");
                        // Iterate over each element and set the attribute 'is-selected' to 'false'
                        elements.forEach(function(element) {
                            element.setAttribute('is-selected', 'false');
                        });
                        cItem.setAttribute('is-selected', 'true');
                        cItem.setAttribute('data-color', props.value);
                        outSide = false;
                    }
                    return props;
                },
                afterRender: (element) => {
                    //console.log('[DBG] ▶️ swatch afterRender start');
                    const props = element.getParams().props;
                    if (props.labelAs !== 'image' && props.displayType !== 'box') return;

                    const baseColor = props.value.split('/')[0].trim();
                    // console.log('[DBG] baseColor:', baseColor);

                    // find ancestor that has props.product
                    let cur = element;
                    let productObj;
                    while (cur) {
                        const p = cur.getParams().props;
                        if (p && p.product) {
                        productObj = p.product;
                        break;
                        }
                        cur = cur.getParentElm();
                    }
                    //console.log('[DBG] resolved productObj:', productObj);
                    if (!productObj) {
                        // console.warn('[DBG] Cannot find productObj, skip');
                        return;
                    }

                    // get metafields array on product
                    const mfArray = productObj.metafields;
                    if (!Array.isArray(mfArray)) {
                        //console.warn('[DBG] No metafields array on product, skip');
                        return;
                    }

                    const mfField = mfArray.find(m =>
                        m.namespace === 'custom' &&
                        m.key       === 'product_variant_color'
                    );
                    if (!mfField) {
                        //console.warn('[DBG] product_variant_color not set, skip');
                        return;
                    }
                    let map;
                    try {
                        map = JSON.parse(mfField.value);
                    } catch (e) {
                        //console.error('[DBG] Invalid JSON in product_variant_color', e);
                        return;
                    }
                    // console.log('[DBG] parsed map:', map);

                    const normalize = str => str.trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
                    const entry = Object.entries(map).find(([k]) => normalize(k) === normalize(baseColor));
                    //console.log('[DBG] found entry:', entry);
                    if (!entry) return;

                    const { hex } = entry[1];
                    if (!hex) return;

                    // Override DOM
                    const btn = element.getRootElm();
                    const label = btn.querySelector('label.boost-sd__radio-label');
                    if (label) {
                        label.style.backgroundImage = 'none';
                        label.style.backgroundColor = hex;
                    }
                }
            }),
        });
    }
]);
// End Boost change name of size options
// check CTA button
// Modify quicAddToCart action
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('CTAButton', {
            apply: () => ({
                props: (props) => {
                    return props;
                },
                render: (elementModel, currentRenderElement) => {
                    if (currentRenderElement.props.action === "quickAddToCart") {
                        const currentOnlickHandler = currentRenderElement.props.onClick
                        currentRenderElement.props.onClick = (e) => {
                            e.preventDefault();
                            const el = e.target
                            const productItemEl = el.closest('.boost-sd__product-item')
                            const quickAddToCartEl = productItemEl.querySelector('.js-quick-add-to-cart quick-add-to-cart')
                            const quickAddToCartOptionEls = quickAddToCartEl.querySelectorAll('.option')
                            const colorSwatches = productItemEl.querySelectorAll('.boost-sd__product-swatch-option')
                            let currentProductColor = colorSwatches[0]?.querySelector('.boost-sd__radio-input')?.value
                            if (quickAddToCartOptionEls.length <= 1) {
                                return currentOnlickHandler()
                            }
                            colorSwatches.forEach((colorSwatch) => {
                                const selectedAttr = colorSwatch.getAttribute('is-selected')
                                if (selectedAttr === 'true') {
                                    currentProductColor = colorSwatch?.querySelector('.boost-sd__radio-input')?.value
                                }
                            })
                            const variantOptions = quickAddToCartEl.querySelectorAll(`.option[data-variant-color="${currentProductColor}"]`)
                            variantOptions.forEach((variantOption) => {
                                variantOption.style.display = 'inline-block'
                            })
                            quickAddToCartEl.classList.add('is-active')
                        }
                    }
                    
                    return currentRenderElement;
                },
                afterRender: (element) => {
                }
            }),
        });
    }
]);
//move addtocart
function addQuickAddOnProductCard(element) {
    let productData = element.getParams().props.product;
    let productItem = document.querySelector('[data-product-id="' + productData.id + '"].boost-sd__product-item');

    let quickAddVariantsDiv = productItem.querySelector('.js-quick-add-to-cart');
    if (!quickAddVariantsDiv) {
        quickAddVariantsDiv = document.createElement('div');
        quickAddVariantsDiv.classList.add('js-quick-add-to-cart')
    }
    let variantItems = ''
    productData.variants.forEach((productVariant) => {
        variantItems += `
            <button
                type="button"
                class="option"
                data-variant-id="${productVariant.id}"
                data-variant-color="${productVariant.merged_options[0].replace('color:', '')}"
                ${productVariant.inventory_quantity <= 0 ? 'disabled="disabled"' : '' }
                style="display: none;"
            >
                ${productVariant.merged_options[1].replace(/^[^:]+:/, '')}
                ${productVariant.inventory_quantity <= 0 ? "<span>(Out of stock)</span>" : '' }
            </button>
        `
    })
    const quickAddVariants = `
        <quick-add-to-cart data-product-id="${productData.id}">
            ${variantItems}
            <button type="button" class="quick-add__submit button button--full-width">
            Add to cart
            </button>
        </quick-add-to-cart>
    `
    quickAddVariantsDiv.innerHTML = quickAddVariants
    productItem.appendChild(quickAddVariantsDiv)
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'customize click swatchOption',
            apply: () => ({
                props: (props) => {
                    return props;
                },
                afterRender: (element) => {
                    setTimeout(() => {
                        let productData = element.getParams().props.product;
                        let isColor = productData.options_with_values
                        const hasSingleColor = isColor.some(item => item.name === "color" && item.values.length === 1);
                        if (hasSingleColor) {
                            let iem = document.querySelector('[data-product-id="' + productData.id + '"] .boost-sd__product-swatch');
                            if (iem) iem.style.display = "none";
                        }
                        var productItems = document.querySelectorAll('[data-product-id="' + productData.id + '"].boost-sd__product-item');
                        productItems.forEach((productItem) => {
                            let selectOptionsButton = productItem.querySelector('.boost-sd__product-image-wrapper .boost-sd__product-image-row--bottom');
                            let flairEl = productItem.querySelector('[data-flair-product-badge]');
                            if (flairEl && productItem.querySelector('.boost-sd__product-title')) {
                                productItem.querySelector('.boost-sd__product-title').before(flairEl);
                            }
                            const priceClone = productItem.querySelector('.boost-sd__product-info .boost-sd__product-price');
                            if (selectOptionsButton && productItem) {
                                productItem.appendChild(selectOptionsButton);
                                productItem.appendChild(priceClone.cloneNode(true));
                                priceClone.remove();
                            }
                        })
                        let productItem = document.querySelector('[data-product-id="' + productData.id + '"].boost-sd__product-item');
                        //move wishlist to after render
                        if (document.querySelector(`div[w-id="${productData.id}"]`)) return;
                        const headerIcons = document.querySelector('.header__icons');
                        const hasModalOpener = headerIcons.querySelector('modal-opener') !== null;
                        wishlistHtml = ``;
                        const wishlistDiv = document.createElement('div');
                        const item = document.querySelectorAll('.boost-sd__product-item');
                        const logged = document.getElementById("logged");
                        item.forEach(i => {
                            if (i.getAttribute('data-product-id') == productData.id) {
                                wishlistHtml = ` <div class="wishlist-engine" data-product_id="${productData.id}" data-variant_id="${productData.variants[0].id }" data-full_button="false" data-css="true"></div>`;
                                    wishlistDiv.innerHTML = wishlistHtml;
                                    if (productItem && !productItem.querySelector(".wishlist-engine")) {
                                        productItem.appendChild(wishlistDiv);
                                }
                                // if(i.querySelector('[data-product-id="' + productData.id + '"].boost-sd__product-item')) i.querySelector('.boost-sd__product-image-row--bottom').innerHTML += wishlistHtml;
                            }
                        });
                        //end move
                        //mobile check recommendation
                        function isMobile() {
                            // This will always return the latest window width status
                            return window.innerWidth <= 1199;
                        }

                        function addActiveHover(active) {
                            productItems.forEach((productItem) => {
                                const productImage = productItem.querySelector(".boost-sd__product-image");
                                if (productImage) { // Ensure productImage exists
                                    if (active) {
                                        productImage.classList.add("active");
                                    } else {
                                        productImage.classList.remove("active");
                                    }
                                }
                            });
                        }
                        // Adjust this function to handle mobile check dynamically
                        function handleMobileView() {
                            if (isMobile()) {
                                productItems.forEach((productItem1) => {
                                    const productImageContainer = productItem1.querySelector(".boost-sd__product-image");
                                    if (!productImageContainer.classList.contains('splide')) {
                                        productImageContainer.classList.add('splide');
                                        const splideTrack = document.createElement('div');
                                        splideTrack.classList.add('splide__track');
                                        const splideList = document.createElement('ul');
                                        splideList.classList.add('splide__list');
                                        const images = productImageContainer.querySelectorAll('img');
                                        images.forEach(function(img) {
                                            const slide = document.createElement('li');
                                            slide.classList.add('splide__slide');
                                            slide.appendChild(img);
                                            splideList.appendChild(slide);
                                        });
                                        splideTrack.appendChild(splideList);
                                        productImageContainer.appendChild(splideTrack);
                                        new Splide(productImageContainer, {
                                            perPage: 1,
                                            arrows: false,
                                            pagination: true,
                                            drag: true,
                                        }).mount();
                                        const paginationContainer = productItem1.querySelector('.splide__pagination');
                                        const targetContainer = productItem1.querySelector('.boost-sd__product-item-grid-view-layout-image');
                                        if (paginationContainer && targetContainer) {
                                            targetContainer.appendChild(paginationContainer);
                                        }
                                    }
                                });
                            }
                        }
                        // Optionally handle window resize to adjust for mobile status
                        window.addEventListener('resize', handleMobileView);
                        handleMobileView();
                        //end mobile check recommendation
                        // custom tooltip button addtocart
                        const buttonAddToCart = document.querySelector('[data-product-id="' + productData.id + '"] .boost-sd__button--show-on-hover.boost-sd__btn-add-to-cart');
                        if (buttonAddToCart) {
                            const ariaLabel = buttonAddToCart.getAttribute('aria-label');
                            buttonAddToCart.setAttribute('title', ariaLabel);
                        }

                        addQuickAddOnProductCard(element);
                    }, 1000)
                },
            }),
        });
    }
]);
// kevin fix hover main
// Function to extract code and suffix from the URL
function extractCodeAndSuffixFromUrl(url) {
    if (!url) {
        console.error('URL is undefined or null');
        return {
            code: '',
            suffix: ''
        };
    }
    let pattern = /-([A-Z]+)_(m?\d+)_/i;
    let match = url.match(pattern);
    if (match && match[1]) {
        const code = match[1];
        const suffix = match[2];
        return {
            code,
            suffix
        };
    } else {
        pattern = /-([A-Z]+)_(\w+)\.jpg/i;
        match = url.match(pattern);
        if (match && match[1]) {
            const code = match[1];
            const suffix = match[2];
            return {
                code,
                suffix
            };
        } else {
            return {
                code: '',
                suffix: ''
            };
        }
    }
}
function findItemWithCodeAndSuffix(originalSize, code, number) {
    const pattern = new RegExp(`${code}_(m?${number})(\\D|$)`, 'i');
    return originalSize.find(item => {
        const src = item.src.toLowerCase();
        const isExcluded = src.includes(`_${number}0`) || src.includes("_a_") || src.includes("_a.") || src.includes("_m10");
        return pattern.test(src) && !isExcluded;
    })?.src;
}

function findFallback(images, number, exclusionSuffix) {
    return images.find(image => {
        const src = image.src.toLowerCase();

        if (src.includes("_a_") || src.includes("_a.")) return false;

        const afterFirstUnderscore = src.split("_")[1]?.split(".")[0];

        return afterFirstUnderscore === String(number);
    });
}


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductImage', {
            name: 'customize main-hover image',
            apply: () => ({
                props: (props, element) => {
                    let data = element.getParentElm().getParentElm().getParams();
                    let newImages = data.props.product?.variants.map(product => product.image).filter((image, index, array) => array.indexOf(image) === index);
                    let isOneColor = false;
                    props.deviceSizes = [800, 900, 1000, 1100, 1200, 1600];

                    // Check if the product has only one color option
                    data.props.product?.options_with_values.map(i => {
                        if (i.name.toLowerCase() == "color" && i.values.length == 1) {
                            isOneColor = true;
                        }
                    });

                    if (isOneColor) {
                        // Logic for products with only one color option
                        function setImageFromRules(images) {
                            let mainImage = images.find(image => image.src.toLowerCase().includes('_m1') && !image.src.toLowerCase().includes('_a_') && !image.src.toLowerCase().includes('_a.') && !image.src.toLowerCase().includes('_m10')) ||
                                findFallback(images, 1, "10") ||
                                findFallback(images, 2, "20");                            
                            let hoverImage = images.find(image => image.src.toLowerCase().includes('_m2') && !image.src.toLowerCase().includes('_a_') && !image.src.toLowerCase().includes('_a.') && !image.src.toLowerCase().includes('_m20')) ||
                                findFallback(images, 2, "20") ||
                                findFallback(images, 3, "30");
                           
                            mainImage = mainImage ? mainImage.src : null;
                            hoverImage = hoverImage ? hoverImage.src : null;
                            props.images[0] = mainImage || props.originalSize[0]?.src || null;
                            props.images[1] = hoverImage || props.originalSize[1]?.src || null;
                        }

                        // Using the function to get the images
                        setImageFromRules(props.originalSize);
                    } else {
                        // Logic for products with multiple colors
                        let attCheck = extractCodeAndSuffixFromUrl(props.images[0]);
                        if (attCheck.code && attCheck.suffix) {
                            if (attCheck.suffix.toLowerCase() == "m1") {
                                // Find hover image similar to the one-color logic
                                let hoverImage = findItemWithCodeAndSuffix(props.originalSize, attCheck.code, "m2") ||
                                                 findItemWithCodeAndSuffix(props.originalSize, attCheck.code, "2");
                                props.images[1] = hoverImage;
                            } else if (attCheck.suffix.toLowerCase() != "m1") {
                                // Find main and hover images similar to the one-color logic
                                let mainImage = findItemWithCodeAndSuffix(props.originalSize, attCheck.code, "m1") ||
                                                findItemWithCodeAndSuffix(props.originalSize, attCheck.code, "1");
                                let hoverImage = findItemWithCodeAndSuffix(props.originalSize, attCheck.code, "m2") ||
                                                 findItemWithCodeAndSuffix(props.originalSize, attCheck.code, "2");

                                // If not found, try with the next sequence number
                                if (!mainImage) {
                                    mainImage = findItemWithCodeAndSuffix(props.originalSize, attCheck.code, "2");
                                    hoverImage = findItemWithCodeAndSuffix(props.originalSize, attCheck.code, "3");
                                }

                                props.images[0] = mainImage || props.originalSize[0]?.src || null;
                                props.images[1] = hoverImage || props.originalSize[1]?.src || null;
                            }
                        }
                        return props;
                    }
                    return props;
                },
            }),
        });
    }
]);


//fix color name
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FilterOption', {
            name: 'customize name of colors',
            apply: () => ({
                afterRender: (element) => {
                    let cItem = element.getRootElm();
                    if (cItem.classList.contains('boost-sd__filter-option-swatch')) {
                        let optionValuesProps = element.getParams().props.option.values;
                        const liElements = cItem.querySelectorAll('li');
                        // Loop through each li element
                        liElements.forEach(li => {
                            if (!li.querySelector(".name-color")) {
                                const button = li.querySelector('button');
                                // Get the title attribute from the button
                                const title = button.getAttribute('title');
                                const matchingItem = optionValuesProps.find(item => item.key === title);
                                if (matchingItem) {
                                    // Create a span element
                                    const span = document.createElement('span');
                                    span.classList.add('name-color');
                                    // Set the text content of the span to the title attribute and doc_count
                                    span.textContent = `${title} (${matchingItem.doc_count})`;
                                    // Append the span to the li element
                                    button.appendChild(span);
                                }
                            }
                        });
                    }
                }
            }),
        });
    }
]);
// Modify ProductPrice
// window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
//     (componentRegistry) => {
//         componentRegistry.useComponentPlugin('ProductPrice', {
//             name: 'Modify ProductPrice',
//             apply: () => ({
//                 afterRender: (element) => {
//                     const productPriceData = element.getParams().props.data;
//                     console.log('Modify ProductPrice', { element,productPriceData, parent: element.getRootElm() });
//                 },
//             })
//         });
//     }
// ]);
// Modify ProductCount
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductCount', {
            name: 'Modify ProductCount',
            apply: () => ({
                afterRender: (element) => {
                    const productCount = element.getRootElm();
                    if (typeof(productCount) != 'undefined' && productCount != null) {
                        const productCountText = productCount.innerHTML;
                        const productCountParent = productCount.parentElement;
                        if (productCountParent) {
                            const productCountCustom = productCountParent.querySelector('.boost-sd__product-count-custom');
                            if (typeof(productCountCustom) != 'undefined' && productCountCustom != null) {
                                let btnCount = productCountCustom.querySelector('.btn-count');
                                btnCount.innerHTML = productCountText.replace("products", "Items");
                            } else {
                                let div = document.createElement("div");
                                div.classList.add('boost-sd__product-count-custom');
                                div.innerHTML = "<span class='btn-count'>" + productCountText.replace("products", "Items") + "</span>";
                                productCount.before(div);
                            }
                        }
                    }
                },
            })
        });
    }
]);
// Modify Sorting
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('Sorting', {
            name: 'Modify Sorting',
            apply: () => ({
                afterRender: (element) => {
                    const sortingLabel = element.getRootElm().querySelector('.boost-sd__sorting-label');
                    if (typeof(sortingLabel) != 'undefined' && sortingLabel != null) {
                        sortingLabel.innerHTML = "Sort by</span>";
                    }
                },
            })
        });
    }
]);
// Modify Filter
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('FilterTree', {
            name: 'Modify Filter',
            apply: () => ({
                afterRender: (element) => {
                    const refineBy = element.getRootElm().querySelector('.boost-sd__refine-by-vertical-refine-by');
                    const refineList = element.getRootElm().querySelectorAll('.boost-sd__refine-by-vertical-refine-by-item');
                    const refineHeading = element.getRootElm().querySelector('.boost-sd__refine-by-vertical-refine-by-heading');
                    const refineHeadingNumber = element.getRootElm().querySelector('.boost-sd__refine-by-vertical-refine-by-heading-number');
                    const number = refineList?.length || 0;
                    console.log('Modify Filter', {
                        refineBy,
                        refineList,
                        refineHeading,
                        refineHeadingNumber,
                        number
                    });
                    const mediaQueryDesktop = window.matchMedia("(min-width:780px)");
                    let currentRefineDefault = element.getRootElm().querySelector('.current-refinements');
                    if (mediaQueryDesktop.matches) {
                        document.querySelector('html').classList.remove('has-filter-mobile');
                        const options = element.getRootElm().querySelectorAll('.boost-sd__filter-tree-vertical-option-list .boost-sd__filter-option.boost-sd__filter-option');
                        if (options === null || options.length === 0) {
                            document.querySelector('html').classList.remove('has-filter');
                            document.querySelector('.boost-sd__filter-tree-toggle-button').classList.remove('showing-filter');
                        } else {
                            document.querySelector('html').classList.add('has-filter');
                            document.querySelector('.boost-sd__filter-tree-toggle-button').classList.add('showing-filter');
                        }
                    } else {
                        document.querySelector('html').classList.remove('has-filter');
                        const filterTree = element.getRootElm().closest('.boost-sd-container').querySelector('.boost-sd__filter-tree-vertical');
                        if (typeof(filterTree) != 'undefined' && filterTree != null) {
                            if (filterTree.classList.contains('boost-sd__filter-tree-vertical--hidden')) {
                                document.querySelector('html').classList.remove('has-filter-mobile');
                                document.querySelector('.boost-sd__filter-tree-toggle-button').classList.remove('showing-filter');
                            } else {
                                document.querySelector('html').classList.add('has-filter-mobile');
                                document.querySelector('.boost-sd__filter-tree-toggle-button').classList.add('showing-filter');
                            }
                        }
                    }
                    window.addEventListener('resize', function() {
                        this.setTimeout(function() {
                            const mediaQueryDesktop = window.matchMedia("(min-width:780px)");
                            const tree = document.querySelector('#boost-sd__filter-tree-wrapper');
                            // const sdRight = document.querySelector('.boost-sd-right');
                            const sdLeft = document.querySelector('.boost-sd-left');
                            if (mediaQueryDesktop.matches) {
                                document.querySelector('html').classList.remove('has-filter-mobile');
                                document.querySelector('.boost-sd__filter-tree-toggle-button').classList.remove('showing-filter');
                                if (tree.closest('.boost-sd-right')) {
                                    console.log('rezise desktop', {
                                        tree
                                    });
                                    // sdLeft.append(tree);
                                    sdLeft.classList.add('boost-sd-left--resize');
                                }
                            } else {
                                document.querySelector('html').classList.remove('has-filter');
                                document.querySelector('.boost-sd__filter-tree-toggle-button').classList.remove('showing-filter');
                                if (tree.closest('.boost-sd-left')) {
                                    console.log('rezise mobile', {
                                        tree
                                    });
                                    sdRight.append(tree);
                                } else {
                                    sdLeft.classList.remove('boost-sd-left--resize');
                                }
                            }
                        }, 0);
                    });
                    if (typeof(refineHeadingNumber) != 'undefined' && refineHeadingNumber != null) {
                        const refineNumber = refineHeadingNumber.querySelector('.filter-number');
                        refineNumber.innerHTML = number;
                    } else if (typeof(refineHeading) != 'undefined' && refineHeading != null) {
                        const div = document.createElement("div");
                        div.classList.add('boost-sd__refine-by-vertical-refine-by-heading-number');
                        div.innerHTML = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>' + "<span class='filter-number'>" + number + "</span> Filters";
                        refineHeading.before(div);
                        const action = document.createElement("button");
                        action.classList.add('boost-sd__button--clear-all');
                        action.innerHTML = "<span>Clear all</span>";
                        refineHeading.after(action);
                        action.addEventListener('click', function() {
                            clearBtn = document.querySelector('.boost-sd__button.boost-sd__button--clear');
                            if (typeof(clearBtn) != 'undefined' && clearBtn != null) {
                                clearBtn.click();
                            }
                        });
                        div.addEventListener('click', function() {
                            if (refineBy.classList.contains('show-title-number')) {
                                refineBy.classList.remove('show-title-number');
                            } else {
                                refineBy.classList.add('show-title-number');
                            }
                        });
                        const actionClose = document.createElement("button");
                        actionClose.classList.add('boost-sd__button-title-close');
                        actionClose.innerHTML = '<span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="#000"><path d="M18.828 16l12.728 12.728-2.828 2.828-12.728-12.728-12.728 12.728-2.828-2.828 12.728-12.728-12.728-12.728 2.828-2.828 12.728 12.728 12.728-12.728 2.828 2.828-12.728 12.728z"></path></svg></span>';
                        refineHeading.after(actionClose);
                        actionClose.addEventListener('click', function() {
                            refineBy.classList.remove('show-title-number');
                        });
                    }
                    if (typeof(refineHeading) != 'undefined' && refineHeading != null) {
                        if (number > 3) {
                            // refineBy.classList.add('show-title-number');
                            refineBy.classList.add('show-popup');
                        } else {
                            refineBy.classList.remove('show-title-number');
                            refineBy.classList.remove('show-popup');
                        }
                    }
                    if ((typeof(refineBy) != 'undefined' && refineBy != null) || !currentRefineDefault) {
                        const currentRefine = element.getRootElm().querySelector('.current-refinements');
                        const refineClear = document.querySelector('#refine-clear');
                        if (typeof(currentRefine) != 'undefined' && currentRefine != null) {
                            currentRefine.classList.add('added-refine');
                            if (refineClear.style.display === 'none') {
                                refineClear.style.display = 'inline';
                            }
                        } else {
                            const filterTreeContent = element.getRootElm().querySelector('.boost-sd__filter-tree-vertical-option-list');
                            let div = document.createElement("div");
                            div.classList.add('current-refinements');
                            div.innerHTML = '<div class="clear-button-alls"><button id="refine-clear" class="action primary">Reset All Filter</button></div><div class="butons-bottoms"><button id="refine-ok" class="btn">OK</button><button id="refine-cancel" class="btn">CANCEL</button></div>';
                            if (!filterTreeContent) return;
                            filterTreeContent.after(div);
                            filterTreeContent.style.paddingBottom = '0px';
                            const refineClear = document.querySelector('#refine-clear');
                            const refineOk = document.querySelector('#refine-ok');
                            const refineCancel = document.querySelector('#refine-cancel');
                            refineClear.addEventListener('click', function() {
                                const clearBtn = document.querySelector('.boost-sd__button.boost-sd__button--clear');
                                if (typeof(clearBtn) != 'undefined' && clearBtn != null) {
                                    clearBtn.click();
                                }
                            });
                            refineOk.addEventListener('click', function() {
                                const filterBtn = document.querySelector('.boost-sd__filter-tree-toggle-button');
                                if (typeof(filterBtn) != 'undefined' && filterBtn != null) {
                                    filterBtn.click();
                                }
                            });
                            refineCancel.addEventListener('click', function() {
                                const filterBtn = document.querySelector('.boost-sd__filter-tree-toggle-button');
                                if (typeof(filterBtn) != 'undefined' && filterBtn != null) {
                                    filterBtn.click();
                                }
                            });
                        }
                    } else {
                        const currentRefine = element.getRootElm().querySelector('.current-refinements');
                        const refineClear = element.getRootElm().querySelector('#refine-clear');
                        const mediaQueryTablet = window.matchMedia("(max-width: 1199px)");
                        if (typeof(currentRefine) != 'undefined' && currentRefine != null && !mediaQueryTablet.matches) {
                            currentRefine.remove();
                        } else if (typeof(currentRefine) != 'undefined' && currentRefine != null && mediaQueryTablet.matches) {
                            refineClear.style.display = 'none';
                        }
                    }
                    // close filter tree when click sorting
                    const filterTreeBtn = element.getRootElm().closest('.boost-sd-container').querySelector('.boost-sd__filter-tree-toggle-button');
                    const sortingBtn = element.getRootElm().closest('.boost-sd-container').querySelector('.boost-sd__sorting-button');
                    document.body.addEventListener('click', function(event) {
                        const mediaQueryTablet = window.matchMedia("(max-width: 1199px)");
                        if (sortingBtn?.contains(event.target) && (document.querySelector('html').classList.contains('has-filter') || document.querySelector('html').classList.contains('has-filter-mobile')) && mediaQueryTablet.matches) {
                            filterTreeBtn.click();
                        }
                    });
                },
            })
        });
    }
]);

// Modify PaginationInfiniteScroll
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('PaginationInfiniteScroll', {
            name: 'Modify PaginationInfiniteScroll',
            apply: () => ({
                afterRender: (element) => {
                    console.log('Modify PaginationInfiniteScroll After Render');
                    const infiniteScroll = document.querySelector('.boost-sd__pagination-infinite-scroll-container-target');
                    if (typeof(infiniteScroll) != 'undefined' && infiniteScroll != null) {
                        infiniteScroll.innerHTML = "<span class='btn-load'>Load More</span>";
                    }

                    const visitedProduct = window.localStorage.getItem('productLinkRemovedClicked');

                    if(visitedProduct && visitedProduct !== '') {
                        console.log('productLinkRemovedClicked', {visitedProduct});
                        const productItem = document.querySelector(`.boost-sd__product-item[data-product-id="${visitedProduct}"]`);
                        if(productItem) {
                            productItem.scrollIntoView();
                            window.localStorage.setItem('productLinkRemovedClicked', '');
                            console.log('Modify ProductLink After Render - Removed productLinkRemovedClicked');
                        } 
                    } 
                }
            })
        });
    }
]);


// Modify ProductLink
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductLink', {
            name: 'Modify ProductLink',
            apply: () => ({
                afterRender: (element) => {
                    // console.log('Modify ProductLink After Render');
                    const productLink = element.getRootElm();
                    // console.log({productLink});
                    $(productLink).on('click', function() {
                        var productId = $(this).parents('.boost-sd__product-item').attr('data-product-id');
                        // console.log('ProductLink Clicked', productId);
                        window.localStorage.setItem('productLinkClicked', productId);
                    });
                }
            })
        });
    }
]);

// Modify ProductList
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        /* Boost-336696 */
        componentRegistry.useModulePlugin('SearchAPI', {
            name: 'The first SearchAPI plugin',
            apply(builder) {
                builder.on('methodFulfilled', 'get', (response) => {
                    const result = response.result;
                    const productData = result?.products || 0;
                    const collectionData = result?.collections || 0;
                    const searchTerm = earchTerm = boostSDAppConfig.generalSettings.search_term.toLowerCase();
                    let newTitle = '';
                    if (productData.length > 0) {
                        newTitle = 'Search: ' + productData.length + ' results found for "' + searchTerm + '" - ' + boostSDAppConfig.shop.name;
                    } else if (collectionData.length > 0) {
                        newTitle = 'Search: ' + collectionData.length + ' results (for collections) found for "' + searchTerm + '" - ' + boostSDAppConfig.shop.name;
                    } else {
                        newTitle = 'Search: 0 results found for "' + searchTerm + '" - ' + boostSDAppConfig.shop.name;
                    }
                    if (newTitle !== '') {
                        document.title = newTitle;
                    }
                });
            }
        });
        /* Boost-336696 */
        componentRegistry.useComponentPlugin('ProductList', {
            name: 'Modify ProductList',
            apply: () => ({
                afterRender: (element) => {
                    const productList = element.getRootElm();
                    const placeholder = productList.querySelector('.boost-sd__product-list-placeholder-item');
                    const data = element.getParams().props;
                    // console.log('Modify ProductList', {
                    //     productList,
                    //     element,
                    //     data,
                    //     parent: productList.parentElement,
                    //     parents: productList.parentElement.parentElement,
                    //     parents1: productList.parentElement.parentElement.parentElement,
                    //     parents2: productList.parentElement.parentElement.parentElement.parentElement,
                    //     parents3: productList.parentElement.parentElement.parentElement.parentElement.parentElement
                    // });
                    if (typeof(placeholder) != 'undefined' && placeholder != null) {
                        // nothing
                    } else {
                        document.querySelector('html').classList.remove('before-render');
                    }

                    // console.log('Modify ProductList After Render', productList);

                    const productLinks = $(productList).find('.boost-sd__product-link');
                    productLinks.each(function() {
                        $(this).on('click', function() {
                            const productId = $(this).parents('.boost-sd__product-item').attr('data-product-id');
                            // console.log('Modify ProductList After Render - ProductLink Clicked', productId);
                            window.localStorage.setItem('productLinkClicked', productId);
                        });
                    });


                    const visitedProduct = window.localStorage.getItem('productLinkClicked');

                    if(visitedProduct && visitedProduct !== '') {
                        console.log(' productLinkClicked', {visitedProduct});
                        const productItem = document.querySelector(`.boost-sd__product-item[data-product-id="${visitedProduct}"]`);
                        if(productItem) {
                            productItem.scrollIntoView();
                            window.localStorage.setItem('productLinkRemovedClicked', visitedProduct);
                            window.localStorage.setItem('productLinkClicked', '');
                            console.log('Removed productLinkClicked');
                        }
                    }
                }
            })
        });
    }
]);

setTimeout(() => {
    const sectionDiv = document.querySelector('div.related-section');
    if (sectionDiv) {
        const parentElement = sectionDiv.parentNode.parentNode;
        if (!document.querySelector('.tab-bottom-product')) {
            const tabElement = document.createElement('div');
            tabElement.classList.add('tab-bottom-product');
            const relatedButton = document.createElement('button');
            relatedButton.classList.add("related-button");
            relatedButton.textContent = 'Recommendations';
            const recentlyButton = document.createElement('button');
            recentlyButton.classList.add("recently-button");
            recentlyButton.textContent = 'Recently Viewed';
            tabElement.appendChild(relatedButton);
            tabElement.appendChild(recentlyButton);
            const firstChild = parentElement.firstChild;
            parentElement.insertBefore(tabElement, firstChild);
            const relatedSection = document.querySelector('.related-section');
            const recentlySection = document.querySelector('.recently-section');
            relatedSection.parentNode.classList.add('active-section');
            recentlySection.parentNode.classList.add('inactive-section');
            relatedButton.classList.add('active');
            recentlyButton.classList.remove('active');
            relatedButton.addEventListener('click', function() {
                relatedSection.parentNode.classList.add('active-section');
                relatedSection.parentNode.classList.remove('inactive-section');
                recentlySection.parentNode.classList.add('inactive-section');
                recentlySection.parentNode.classList.remove('active-section');
                relatedButton.classList.add('active');
                recentlyButton.classList.remove('active');
            });
            recentlyButton.addEventListener('click', function() {
                relatedSection.parentNode.classList.add('inactive-section');
                relatedSection.parentNode.classList.remove('active-section');
                recentlySection.parentNode.classList.add('active-section');
                recentlySection.parentNode.classList.remove('inactive-section');
                relatedButton.classList.remove('active');
                recentlyButton.classList.add('active');
            });
        }
    }
}, 2000);

// Add loading spinner
const boostsd = document.querySelector('.boost-sd__product-filter-fallback');
if (typeof(boostsd) != 'undefined' && boostsd != null) {
    document.querySelector('html').classList.add("before-render");
}

document.querySelector('.popup__close-button').addEventListener('click', function() {
    document.querySelector('.cart-popup-inner').classList.remove('active');
});

class QuickAddToCart extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    this.optionButtons = this.querySelectorAll('button.option');
    if (this.optionButtons.length === 0) return;

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.submitButton = this.querySelector('button.quick-add__submit');
    this.triggerButton = document.querySelector(`button[data-trigger-quick-add-to-cart="${this.dataset.productId}"]`);
    this.cartErrorPopup = document.querySelector("#cart-popup");

    this.attachEventListeners();
  }

  attachEventListeners() {
    if (this.triggerButton) {
      this.triggerButton.addEventListener('click', this.handleTriggerClick.bind(this));
    }

    if (this.submitButton) {
      this.submitButton.addEventListener('click', () => this.classList.remove('is-active'));
    }

    document.addEventListener('click', this.handleDocumentClick.bind(this));

    this.optionButtons.forEach(button => {
      button.addEventListener('click', this.handleOptionClick.bind(this));
    });
  }

  handleTriggerClick(event) {
    event.stopPropagation();
    document.querySelectorAll('quick-add-to-cart').forEach(el => el.style.display = 'none');
    this.classList.add('is-active');
  }

  handleDocumentClick(event) {
    document.dispatchEvent(new CustomEvent('geoRedirectClosed'));
    
    const quickAddToCartContainer = event.target.closest(`.boost-sd__product-item[data-product-id="${this.dataset.productId}"]`);
    if (!quickAddToCartContainer && this.classList.contains('is-active')) {
      this.classList.remove('is-active');
    }
  }

  async handleOptionClick(event) {
    event.stopPropagation();
    this.submitButton.classList.add('button-adding');

    const variantId = event.target.dataset.variantId;
    const formData = new FormData();
    formData.append('id', variantId);

    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    try {
      const response = await this.addToCart(formData);
      this.handleAddToCartResponse(response, variantId);
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      if (this.cart && this.cart.classList.contains('is-empty')) {
        this.cart.classList.remove('is-empty');
      }
    }
  }

  async addToCart(formData) {
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    const response = await fetch(`${routes.cart_add_url}`, config);
    return response.json();
  }

  handleAddToCartResponse(response, variantId) {
    if (response.status) {
      this.handleCartError(response, variantId);
    } else if (!this.cart) {
      window.location = window.routes.cart_url;
    } else {
      this.handleCartSuccess(response, variantId);
    }

    this.classList.remove('is-active');
    this.submitButton.classList.remove('button-adding');
  }

  handleCartError(response, variantId) {
    publish(PUB_SUB_EVENTS.cartError, {
      source: 'product-form',
      productVariantId: variantId,
      errors: response.errors || response.description,
      message: response.message
    });

    this.showCartErrorPopup(response.message);
  }

  handleCartSuccess(response, variantId) {
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'product-form',
      productVariantId: variantId,
      cartData: response
    });

    this.cart.renderContents(response);
  }

  showCartErrorPopup(message) {
    this.cartErrorPopup.querySelector("p").innerHTML = message;
    this.cartErrorPopup.style.display = 'block';
    setTimeout(() => {
      this.cartErrorPopup.style.display = 'none';
    }, 3000);
  }
}

customElements.define('quick-add-to-cart', QuickAddToCart);

function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

// function isSafari() {
//     var userAgent = navigator.userAgent;
//     return /Safari/.test(userAgent) && /Apple Computer/.test(navigator.vendor);
// }

if (isSafari()) {
    // Your detachment logic here
    console.log("User is browsing with Safari");
}

document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
        // console.log('Page is hidden');
    } else {
        // console.log('Page is visible');
        const visitedProduct = window.localStorage.getItem('productLinkClicked');

        if(isSafari() && visitedProduct && visitedProduct !== '') {
            console.log(' productLinkClicked', {visitedProduct});
            const productItem = document.querySelector(`.boost-sd__product-item[data-product-id="${visitedProduct}"]`);
            if(productItem) {
                productItem.scrollIntoView();
                window.localStorage.setItem('productLinkClicked', '');
                console.log('Removed productLinkClicked');
            }
        }
    }
});